import { setPageDetails, pushEventInfo } from './analytics';
export const setStartEnrollmentAnalytics = () => {
    const event = {
        category: {
            primaryCategory: 'button submission',
        },
        eventInfo: {
            eventName: 'my account settings',
        },
        myAccount: {
            settings: 'instant checkout: summary: get started',
        },
    };
    pushEventInfo(event);
};
export const setToggleEnrollmentAnalytics = (toggleStatus) => {
    const event = {
        category: {
            primaryCategory: 'button submission',
        },
        eventInfo: {
            eventName: 'my account settings',
        },
        myAccount: {
            settings: `instant checkout: summary: toggle: ${toggleStatus}`,
        },
    };
    pushEventInfo(event);
};
export const setChangeEnrolledDetailsAnalytics = (section, option) => {
    const event = {
        category: {
            primaryCategory: 'button submission',
        },
        eventInfo: {
            eventName: 'my account settings',
        },
        myAccount: {
            settings: `instant checkout: summary: ${section}: ${option}`,
        },
    };
    pushEventInfo(event);
};
export const setPartialEnrolledAnalytics = (option) => {
    const settingsInfo = option === 'address'
        ? 'set up where you get it'
        : 'payment method: set up how you pay';
    const event = {
        category: {
            primaryCategory: 'button submission',
        },
        eventInfo: {
            eventName: 'my account settings',
        },
        myAccount: {
            settings: `instant checkout: summary: partial enroll: ${settingsInfo}`,
        },
    };
    pushEventInfo(event);
};
export const setSuccessfullyEnrolledAnalytics = () => {
    const event = {
        category: {
            primaryCategory: 'button submission',
        },
        eventInfo: {
            eventName: 'instant checkout enrolled',
        },
    };
    pushEventInfo(event);
};
export const setICSummaryPageViewAnalytics = () => {
    const page = {
        category: {
            primaryCategory: 'account',
            subCategory1: 'account>instant checkout',
            subCategory2: 'account>instant checkout',
        },
        pageInfo: {
            pageName: 'account>instant checkout',
            pageType: 'maml: instant checkout',
        },
        error: [],
    };
    setPageDetails(page);
};
